import { render, staticRenderFns } from "./WizardFooter.vue?vue&type=template&id=4f04ef78"
import script from "./WizardFooter.vue?vue&type=script&lang=js"
export * from "./WizardFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports